<ng-container *ngIf="type === 'series'">
  <content-loader
    speed="2"
    width="900"
    height="507"
    viewBox="0 0 900 507"
    primaryColor="#2D3035"
    secondaryColor="#353535"
  >
    <svg:rect x="30" y="20" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="30" y="149" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="30" y="171" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="243" y="20" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="243" y="149" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="243" y="171" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="455" y="20" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="455" y="149" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="455" y="171" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="667" y="20" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="667" y="149" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="667" y="171" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="30" y="210" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="30" y="340" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="30" y="364" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="243" y="210" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="455" y="210" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="667" y="210" rx="0" ry="0" width="200" height="120" />
    <svg:rect x="243" y="340" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="455" y="340" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="667" y="340" rx="0" ry="0" width="200" height="15" />
    <svg:rect x="243" y="364" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="455" y="364" rx="0" ry="0" width="140" height="15" />
    <svg:rect x="667" y="364" rx="0" ry="0" width="140" height="15" />
  </content-loader>
</ng-container>
